import DialogContentText from "@mui/material/DialogContentText";
import React from "react";

import { language } from "../../language";
import GenericModal from "../modal-closebtn";

function ConfirmModal(props) {
  const { title, textMessage, handleDialogClose, handleSubmit, openDialog } =
    props;

  const handleClose = () => {
    handleDialogClose();
  };

  const onSubmit = () => {
    handleSubmit();
    handleDialogClose();
  };

  return (
    <GenericModal
      title={title}
      handleSubmit={onSubmit}
      handleClose={handleClose}
      btnActionTitle={language.confirm}
      btnCancelTitle={language.cancel}
      size="xs"
      open={openDialog}
    >
      <DialogContentText className="text-center" id="alert-dialog-description">
        {textMessage}
      </DialogContentText>
    </GenericModal>
  );
}

export { ConfirmModal };
